import { render, staticRenderFns } from "./TileRejectQuantity.vue?vue&type=template&id=20136e4c"
import script from "./TileRejectQuantity.vue?vue&type=script&lang=js"
export * from "./TileRejectQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports